import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import "./admin-department-create-panel.scss";

const AdminDepartmentFormBottomColumnNew = ({
  isEdit,
  setPanelVisibility,
  isSubmitting,
  submitForm,
}) => {
  const enterKeySubmission = (keyEvent, submitForm) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      submitForm && submitForm();
    }
  };

  const enterKeyCancel = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      setPanelVisibility((prev) => ({ ...prev, showCancelPanel: true }));
    }
  };

  return (
    <Form.Row>
      <ButtonToolbar className="department-btn-container">
        <Button
          className="btn-wide"
          type="submit"
          onKeyDown={(keyEvent) => enterKeySubmission(keyEvent, submitForm)}
          disabled={isSubmitting}
        >
          {isEdit ? "Save" : "Create"}
        </Button>
        <Button
          onKeyDown={(keyEvent) => enterKeyCancel(keyEvent)}
          className="btn-wide btn-outlined"
          onClick={() =>
            setPanelVisibility((prev) => ({
              ...prev,
              showCancelPanel: true,
            }))
          }
        >
          Cancel
        </Button>
      </ButtonToolbar>
    </Form.Row>
  );
};

AdminDepartmentFormBottomColumnNew.propTypes = {
  submitForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setPanelVisibility: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
};
export default AdminDepartmentFormBottomColumnNew;
